import { CheckCircle, Cancel, EditOutlined } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Can } from "src/shared/lib/rback/Can";
import { ITargetingSetting } from "../types/types";

export const getColumns = (
  onEdit: (row: ITargetingSetting) => void,
): GridColDef<ITargetingSetting>[] => [
  {
    field: "id",
    headerName: "ID",
    width: 100,
    sortable: true,
  },
  {
    field: "service",
    headerName: "Рекламный сервис",
    flex: 1,
    minWidth: 200,
    sortable: false,
    valueGetter: (_value, row) => row.service.name,
  },
  {
    field: "country",
    headerName: "Страна",
    flex: 1,
    minWidth: 220,
    sortable: true,
    valueGetter: (_value, row) => row.country.name,
  },
  {
    field: "is_active",
    headerName: "Активен",
    width: 120,
    sortable: true,
    valueGetter: (_value, row) => row.is_active,
    renderCell: ({ row }) => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {row.is_active ? (
          <CheckCircle color="success" fontSize="small" />
        ) : (
          <Cancel color="error" fontSize="small" />
        )}
      </Box>
    ),
  },
  {
    field: "actions",
    headerName: "",
    width: 80,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    align: "center",
    renderCell: ({ row }) => (
      <Can perform="system.targeting.edit">
        <Tooltip title="Редактировать">
          <IconButton
            size="small"
            onClick={() => onEdit(row)}
            aria-label="Изменить настройки провайдера"
          >
            <EditOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
    ),
  },
];
